<div role="status" aria-live="polite" aria-atomic="false" class="fixed top-4 right-4 z-50 flex w-80 flex-col gap-2">
    @for (toast of toasts(); track toast.id) {
    <div [@toastAnimation] [class]="toastClasses(toast.type)">
        <span>{{ toast.message }}</span>
        <button type="button" (click)="dismiss(toast.id)" aria-label="Dismiss notification"
            class="shrink-0 font-bold leading-none opacity-60 hover:opacity-100 cursor-pointer">×</button>
    </div>
    }
</div>